/**
 * pages/myAssignments.logic.js — «МИНИЙ ДААЛГАВАР»-ын ЦЭВЭР ЛОГИК.
 *
 * ⚠ ЯАГААД ТУСДАА ФАЙЛ ВЭ:
 *   Шүүлт ба эрэмбэ нь ажилтан «юуг түрүүлж хийх вэ» гэдгийг шийддэг.
 *   Буруу бол хугацаа хэтэрсэн даалгавар жагсаалтын дундуур тарж,
 *   хэн ч гомдол мэдүүлэх хүртэл мэдэгдэхгүй. React-ийн дотор сууж
 *   байвал тестлэхэд бүтэн компонент угсрах шаардлагатай; энд ямар ч
 *   хамааралгүй тул шууд тестлэгдэнэ (tests/myAssignments.logic.test.js).
 */

/** Хугацаагүй даалгаврыг ХАМГИЙН СҮҮЛД тавих түлхүүр. */
const FAR_FUTURE = "9999-99-99";

/**
 * Табын шүүлт.
 *
 * ⚠ «overdue» нь ТӨЛӨВ БИШ, ШИНЖ: «хийх ёстой» ба «баталгаажуулах
 *   хүлээж буй» хоёуланд тохиолдоно. Тиймээс төлөвтэй жишихгүй.
 */
export function matchesTab(row, tab) {
  const st = (row && row.fix_status) || "open";
  if (tab === "all") return true;
  if (tab === "overdue") return !!(row && row.is_overdue);
  if (tab === "open") return st === "open" || st === "in_progress";
  return st === tab;
}

/**
 * ЯАРАЛТАЙ БАЙДЛААР эрэмбэлэх жиших функц.
 *
 *   ① хугацаа хэтэрсэн нь дээр
 *   ② дуусах хугацаа ойр нь дээр (хугацаагүй нь доор)
 *   ③ эцэст нь шалгалтын дугаараар — ижил өдрийнхийг бүлэглэнэ
 *
 * ⚠ Урьд нь ЗӨВХӨН шалгалтын кодоор эрэмбэлдэг байсан. Код нь ажилтанд
 *   ямар ч утгагүй дугаар бөгөөд хэтэрсэн ажлыг нуудаг байв.
 */
export function compareUrgency(a, b) {
  const ao = !!(a && a.is_overdue);
  const bo = !!(b && b.is_overdue);
  if (ao !== bo) return ao ? -1 : 1;
  const ad = String((a && a.due_date) || FAR_FUTURE);
  const bd = String((b && b.due_date) || FAR_FUTURE);
  if (ad !== bd) return ad.localeCompare(bd);
  return String((a && a.inspection && a.inspection.code) || "").localeCompare(
    String((b && b.inspection && b.inspection.code) || ""),
  );
}

/** Шүүж, эрэмбэлсэн жагсаалт. Оролтыг ӨӨРЧЛӨХГҮЙ (хуулбар дээр ажиллана). */
export function visibleRows(rows, tab) {
  return (rows || []).filter((r) => matchesTab(r, tab)).sort(compareUrgency);
}
